import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getMultiPlatformPlatformByPlatformIdLocationCoordinates } from "@/api/methods";
import { requestGuestPosition } from "@/modules/anonymousBrowsing/requestGuestPosition";

import { suggestSignUpLocation } from "./suggestSignUpLocation";

/**
 * `shareDevicePosition` is false until the patient has agreed to share their position, so the
 * system prompt never appears unexplained; until then the IP-derived nearest branch suggests.
 */
export const useSignUpLocationSuggestion = (
  platformId: string,
  enabled: boolean,
  shareDevicePosition: boolean,
) =>
  useQuery({
    queryKey: ["signUpLocationSuggestion", platformId, { shareDevicePosition }],
    queryFn: async () => {
      // Keep the patient's coordinates inside this calculation; only the suggested branch is cached.
      const [coordinates, position] = await Promise.all([
        getMultiPlatformPlatformByPlatformIdLocationCoordinates({ platformId }),
        shareDevicePosition ? requestGuestPosition() : null,
      ]);
      return suggestSignUpLocation(coordinates, position);
    },
    enabled,
    // Agreeing to share swaps the city hint for a precise one without blanking it in between.
    placeholderData: keepPreviousData,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    gcTime: 0,
    throwOnError: false,
  });
